import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface DeactivateObjectModalProps {
  opened: boolean;
  objectName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const DeactivateObjectModal = ({
  opened,
  objectName,
  onClose,
  onConfirm,
  loading,
  isPaused
}: DeactivateObjectModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      danger
      title={t('objectRegistry.deactivateTitle')}
      message={t('objectRegistry.deactivateMessage', { name: objectName })}
      confirmLabel={t('objectRegistry.deactivateConfirm')}
    />
  );
};
